import React from 'react'
import {INameQuantified, IRecipe} from '../../../api/IRecipe'
import {ingredientDisplay} from '../utils/Convertion'
import {Box, capitalize, Typography} from "@mui/material";
import {capitalizeAndPunctuation} from "../../../utils/Text";
import TitleTypography from "../../../components/TitleTypography";
import {useTranslation} from 'react-i18next';

interface IViewIngredientsAndToolsProps {
  recipe: IRecipe
}
const ViewIngredientsAndTools = ({recipe}: IViewIngredientsAndToolsProps): JSX.Element => {
  const groups = [...new Set(recipe.recipeIngredients.filter(i => i.for !== 'n/a' && i.for !== '').map(i => i.for))]
  const { t } = useTranslation();

  return (
    <>
      <TitleTypography>{t('recipe.ingredients')}</TitleTypography>
      <Typography variant="subtitle1">
        {t('common.for')} {recipe.recipeYield} {t('common.persons')}
      </Typography>
      <Typography variant="subtitle2">
        {recipe.recipeIngredients.map((ing: INameQuantified, i: number) => {
          return (
            <div key={i}>
              {(ing.for === '' || ing.for === 'n/a') && ingredientDisplay(ing)}
            </div>
          )
        })}
      </Typography>
      <Typography variant="subtitle2">
        {groups.map((g, i) => (
          <div key={i}>
            <Typography sx={{fontWeight: '900'}}>{capitalizeAndPunctuation(g, ':')}</Typography>
            {recipe.recipeIngredients.map((ing: INameQuantified, ii: number) => {
              return (
                <div key={ii}>
                  {ing.for === g && ingredientDisplay(ing)}
                </div>
              )
            })}
          </div>
        ))}
      </Typography>
      {recipe.tool && recipe.tool.length > 0 && <TitleTypography marginTop={1}>{t('recipe.tools')}</TitleTypography>}
      {recipe.tool && recipe.tool.length > 0 && <Typography variant="subtitle2">
        {recipe.tool && recipe.tool.map((tool: INameQuantified, idx: number) => {
          return (
            <Box key={idx}>{tool.quantity !== 1 && tool.quantity} {capitalize(tool.name)}</Box>
          )
        })}
      </Typography>}
    </>
  )
}

export default ViewIngredientsAndTools
